import {Component, ElementRef, HostBinding, Inject, OnInit, PLATFORM_ID} from "@angular/core";
import {FelloApiService, mixinDestroyable} from "fello-common";
import {ActivatedRoute} from "@angular/router";
import {delay, map, switchMap, takeUntil, tap} from "rxjs/operators";
import {WidgetSettingsService} from "../../services/widget-settings.service";
import {AgencyWidgetSettingResponse, ButtonStyle, WidgetStyleToClassMap} from "fello-model";
import {isPlatformBrowser} from "@angular/common";
import {NgxSpinnerService} from "ngx-spinner";
import {WidgetTrackingService} from "../../services/widget-tracking.service";
import {of} from "rxjs";

@Component({
  selector: "app-search-widget",
  templateUrl: "./search-widget.component.html",
  styleUrls: ["./search-widget.component.scss"],
  providers: [WidgetSettingsService, WidgetTrackingService]
})
export class SearchWidgetComponent extends mixinDestroyable(class {}) implements OnInit {
  address: string;
  widgetId: string;
  isLoading = false;
  widgetSettings: AgencyWidgetSettingResponse;
  spinnerName = "widget-spinner";

  @HostBinding("class")
  get styleClass(): string {
    return WidgetStyleToClassMap[this.widgetSettings?.theme?.button?.style ?? ButtonStyle.ROUNDED];
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private felloApiService: FelloApiService,
    private widgetSettingsService: WidgetSettingsService,
    private elementRef: ElementRef,
    private loaderService: NgxSpinnerService,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) private platformId: Object,
    private widgetTrackingService: WidgetTrackingService
  ) {
    super();
  }

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(
        takeUntil(this.isDestroyed),
        map(params => params.widgetId),
        tap(widgetId => (this.widgetId = widgetId)),
        switchMap(() => {
          if (isPlatformBrowser(this.platformId)) {
            return this.widgetTrackingService.trackView();
          }
          return of(null);
        })
      )
      .subscribe();

    this.widgetSettingsService.settings$
      .pipe(
        takeUntil(this.isDestroyed),
        tap(settings => (this.widgetSettings = settings)),
        delay(50),
        tap(() => this.signalResize())
      )
      .subscribe();
  }

  submit() {
    this.isLoading = true;
    this.loaderService.show(this.spinnerName);
    this.felloApiService
      .initForWidget(this.widgetId, this.address, this.getReferrerUrl())
      .pipe(
        takeUntil(this.isDestroyed),
        tap(
          ({url}) => {
            if (isPlatformBrowser(this.platformId)) {
              if (window.top) {
                window.top.location.href = url;
              }
            }
          },
          () => {
            this.isLoading = false;
            this.loaderService.hide(this.spinnerName);
          }
        )
      )
      .subscribe();
  }

  getReferrerUrl(): string | undefined {
    if (!document.referrer) {
      return undefined;
    }
    const referrerURL = new URL(document.referrer);
    if (referrerURL.host.includes("hifello.com")) {
      return undefined;
    }
    return document.referrer;
  }

  signalResize(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.parent?.postMessage(
        {
          src: "fsw",
          height: this.elementRef.nativeElement.scrollHeight + 3 * 48 // 144px for address suggestion
        },
        "*"
      );
    }
  }
}
